import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dylan from "../assets/helmet.jpg";
import PixelDylan from "../assets/kid_Dylan_Pixel2.jpg";
import React from "react";
import Projects from "../components/Projects";
import Footer from "../components/Footer";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Navbar from "../components/Navbar";
import { useState, useEffect } from "react";
import Fade from "@mui/material/Fade";
import TechStack from "../components/TechStack";
import Researches from "../components/Researches";
import Experience from "../components/Experience";

const loadingTexts = ["Tianxiang Ren"];

function Home() {
  const [textProgress, setTextProgress] = useState(0);
  const [imageSrc, setImageSrc] = useState(Dylan);

  const handleMouseOver = () => setImageSrc(PixelDylan);
  const handleMouseOut = () => setImageSrc(Dylan);

  useEffect(() => {
    const totalTextLength = loadingTexts.reduce((total, text) => total + text.length, 0);
    const timer = setInterval(() => {
      setTextProgress((prev) => prev + 1);
    }, 100);
    if (textProgress >= totalTextLength) clearInterval(timer);
    return () => clearInterval(timer);
  }, [textProgress]);

  return (
    <section>
      <Container>
        <Navbar />

        <Row style={{ alignItems: "flex-start" }}>

          {/* Left: all main content */}
          <Col lg={9} md={9}>

            {/* Hero */}
            <div style={{ display: "flex", alignItems: "center", minHeight: "70vh" }}>
              <div className="p-4">
                {loadingTexts.map((text, index) => (
                  <a key={index} href="/me">
                    <h1 className="name py-4" style={{ textAlign: "left" }}>
                      <ArrowForwardIosIcon xs={{ fontSize: "large", color: "red" }} />{" "}
                      {text.substring(0, textProgress)}
                    </h1>
                  </a>
                ))}
                <br />
                <Fade in={true} timeout={3000}>
                  <div>
                    <p className="intro" style={{ textAlign: "left" }}>
                      Software Engineer at Reputation.com
                    </p>
                    <p className="intro" style={{ textAlign: "left" }}>
                      Full-stack engineer with a focus on React, TypeScript, Java, and Python. I build products — from consumer mobile apps with React Native to enterprise SaaS platforms.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>

            {/* Divider */}
            <Row className="d-flex justify-content-start" style={{ paddingTop: 60 }}>
              <Col lg={10}><hr /></Col>
            </Row>

            {/* Projects */}
            <Row style={{ paddingTop: 100 }} id="projects">
              <Projects />
            </Row>

            {/* Researches */}
            <Row style={{ paddingTop: 100 }} id="researches">
              <Researches />
            </Row>

            {/* TechStack */}
            <Row style={{ paddingTop: 100 }} id="techs">
              <TechStack />
            </Row>

          </Col>

          {/* Right: sticky sidebar */}
          <Col
            lg={3} md={3}
            style={{
              position: "sticky",
              top: "40px",
              alignSelf: "flex-start",
              paddingLeft: "120px",
            }}
          >
            <div style={{ paddingTop: "28vh", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Fade in={true} timeout={3000}>
                <img
                  src={imageSrc}
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                  alt="avatar"
                  style={{ width: "170px", height: "170px", borderRadius: "50%", objectFit: "cover" }}
                />
              </Fade>
              <div style={{ marginTop: 40, width: "100%" }}>
                <Experience />
              </div>
            </div>
          </Col>

        </Row>

        <Footer />
      </Container>
    </section>
  );
}

export default Home;
